import Partners from './components/Partners.vue';
import PartnerCard from './components/PartnerCard.vue';

Vue.component('partners', Partners);
Vue.component('partner-card', PartnerCard);

new Vue({
    component: Partners
}).$mount('#partners')
